export default __webpack_public_path__ + "static/media/llogo.b075c0c9.svg";